// extracted by mini-css-extract-plugin
module.exports = {"rightHeaderWrapper":"RSv2oRgh","negative":"H1Oxusvl","rightHeaderReturnLabel":"jecdzNrR","rightHeaderReturnValue":"aRIJYHLe"};